import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import styled, { createGlobalStyle } from 'styled-components';
import { Flex, Box } from '@rebass/grid';

import { DynamicThemeProvider } from '@amtrav/themes';
import { MatchMedia, media, getTokenValue, SPACE, THEME_TOKENS } from '@amtrav/theme-system';
import { CustomerServiceCTA, HeaderMobile, Sidebar, AccountSetupPage, SignUpContent } from '../../components';
import AcceptInviteForm from './AcceptInviteForm';
import MarketingBubblesEquation from './MarketingBubblesEquation';
import { amtravHome } from './consts';
import InviteCard from './InviteCard';
import SignInLink from '../../components/account-setup/SignInLink';
import { IntroMessage } from '../../components/account-setup/AccountSetupLayout';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  html {
    background-color: ${getTokenValue(THEME_TOKENS.navigation.color.sectionBackground)};
  }
`;

export const ErrorContent = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding-top: ${SPACE.size32};

  ${media.Large`
    width: 624px;
    padding-top: 50px;
  `};

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    display: block;
  }
`;

const FormWrapper = styled(Box)`
  height: auto;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 48px;
`;

const ErrorText = styled.div`
  line-height: 1.4;
  margin: 0 auto;
  padding: 16px;
  font-size: 16px;
  margin: 0 auto 22px auto;
`;

const ErrorTitle = styled.div`
  text-align: center;
  line-height: 1.4;
  margin: 0 auto;
  padding: 16px;
  font-size: 32px;
  margin: 0 auto 22px auto;
  padding: 0;
`;

const Subhead = () => {
  return <div>Friction Free Travel</div>;
};

const AcceptInviteApp = ({ meetingInfo, meetingError }) => {

  return (
    <DynamicThemeProvider themeName="cava">
      <GlobalStyle />
      <AccountSetupPage flexDirection={['column', 'column', 'column', 'row']}>
        {/* AMTRAV HEADER - tablet & smaller */}
        <MatchMedia.MediumAndLess>
          <HeaderMobile homeUrl={amtravHome} />
        </MatchMedia.MediumAndLess>
        {/* LEFT SIDEBAR - 960px & larger */}
        <MatchMedia.Large>
          <Flex flexDirection="column">
            <Sidebar
              marketingContent={<MarketingBubblesEquation />}
              subheadMessage={<Subhead />}
              homeUrl={amtravHome}
            />
          </Flex>
        </MatchMedia.Large>

        {!meetingError ? (
          <>
            <SignUpContent flexDirection="column">
              <IntroMessage>Welcome! Enter your email to start booking your trip.</IntroMessage>
              {meetingInfo && <InviteCard meetingInfo={meetingInfo} />}
              <FormWrapper>
                <AcceptInviteForm />
              </FormWrapper>
              <Flex px={[3, 3, 0]} flexDirection="column" width="100%">
                <CustomerServiceCTA />
              </Flex>
            </SignUpContent>
          </>
        ) : (
          <ErrorContent flexDirection="column">
            <ErrorTitle>We apologize for the inconvenience.</ErrorTitle>
            <ErrorText>{meetingError}</ErrorText>
            <SignInLink />
            <Flex px={[3, 3, 0]} flexDirection="column" width="100%">
              <CustomerServiceCTA />
            </Flex>
          </ErrorContent>
        )}
      </AccountSetupPage>
    </DynamicThemeProvider>
  );
};

AcceptInviteApp.propTypes = {
  meetingInfo: PropTypes.shape({
    meeting: PropTypes.shape({
      meeting: PropTypes.shape({
        startDate: PropTypes.number,
        location: PropTypes.shape({
          shortDisplay: PropTypes.string,
        }),
        name: PropTypes.string,
      }),
    }),
  }),
  meetingError: PropTypes.string,
};

export default process.env.USE_HMR ? hot(AcceptInviteApp) : AcceptInviteApp;
